
    <a href="{{url || '/'}}" [ngStyle]="{color: color || 'white'}">
      <img class="logo"
           src="/assets/images/logo.svg"
           onerror="this.onerror=null; this.src='/assets/images/logo.png'"
           alt="Girko.net logo"/>
      <span class="text">{{label || 'GIRKO'}}</span>
    </a>
  